import { useCallback, useMemo, useState } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { getSession, setSession } from 'common/utils';
import type { MobilePlatform } from 'features/onboarding';
import { useAppRouter } from './hooks';

window.referrer = window.location.href;

const sessionStorageKey = 'mobileUserContinueInBrowser';
const getContinueInBrowser = () => getSession(sessionStorageKey);
const setContinueInBrowser = () => {
  setSession(sessionStorageKey, 'true');
};

const getPlatform = (): Platform => {
  if (/android/i.test(navigator.userAgent)) {
    return 'android';
  }

  if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
    return 'ios';
  }

  return 'web';
};

export type Platform = 'web' | MobilePlatform;

export type RouterConfig = {
  isMobileRouter: boolean;
  onContinueInBrowser: () => void;
  platform: Platform;
};

const Router = () => {
  const platform = useMemo(() => getPlatform(), []);
  const [isMobileRouter, setIsMobileRouter] = useState(!getContinueInBrowser() && platform !== 'web');

  const onContinueInBrowser = useCallback(() => {
    setIsMobileRouter(false);
    setContinueInBrowser();
  }, []);

  const appRouter = useAppRouter({ isMobileRouter, onContinueInBrowser, platform });
  const routerProvider = useMemo(() => createBrowserRouter(appRouter), [appRouter]);

  return <RouterProvider key={isMobileRouter ? 'mobile' : 'web'} router={routerProvider} />;
};

export default Router;
